import request from '@/plugins/axios'

export function getBaseData (data) {
  return request({
    url: '/loadBaseData',
    method: 'post',
    data
  })
}